<div class="signature-button">
  <button mat-button color="accent" type="button" (click)="clearSignature()" [disabled]="disabled">Clear Signature</button>
</div>
<div class="signature-region" #signatureRegion>
  <signature-pad [options]="options" (onEndEvent)="drawComplete()"></signature-pad>
</div>
